export const SIDEBAR_OPTIONS = {
  UNEXPANDED_WIDTH: 48,

  EXPANDED_WIDTH: {
    MINIMUM: 168,
    RECOMMENDED: 210,
    MAXIMUM: 500,
  },
} as const;
